<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Suppression de document</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">Vous êtes sur le point de supprimer le document '{{ data.subject }}'.</p>
            <p class="text">Ce document sera supprimé logiquement jusqu'à l’archivage du dossier où il sera supprimé définitivement.</p>
            <p class="text">Les fichiers attachés au document seront également supprimés (Si le fichier appartenait à vos favoris, il sera retiré des favoris).</p>
            <p class="text">Voulez vous continuer ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Valider</button>
    </mat-card-actions>
</mat-card>
